import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: 'auto',
    maxWidth: 504,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    height: 600,
    overflowY: 'scroll',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 5,
    marginBottom: 25,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  datePickerInput: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  lineUnderButton: {
    backgroundColor: theme.palette.grey[300],
    height: 2,
    width: '100%',
    marginTop: 17,
    marginBottom: 17
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    justifyContent: 'flex-end',
    marginTop: 20
  },
  buttonOfDate: {
    width: '100%',
    height: 50,
    textAlign: 'left',
    '& span': {
      margin: '12px 0px',
      fontSize: 14
    }
  },
  textShowOnButtonParrent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  textShowOnButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginLeft: -48
  },
  textShowOnButtonAfterClickOnTimePeriodButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '100%',
    marginBottom: -16,
    marginLeft: -48,
    '& p:last-child': {
      marginLeft: 12
    }
  },
  textShowOnButtonAfterSelectDateForArrivalDateAndDeparture: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '87%',
    marginBottom: -8,
    justifyContent: 'space-evenly',
    '& p': {
      color: `${theme.palette.grey[100]} !important`
    },
    '& p:last-child': {
      marginLeft: 20
    }
  },
  typographyOfButton: {
    color: `${theme.palette.grey[200]} !important`
  },
  typographyOfButtonAfterSelectDate: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 12,
    fontWeight: 500
  },
  typographyOfButtonAfterSelectDateForArrivalDateAndDeparture: {
    color: `${theme.palette.grey[300]} !important`,
    fontSize: 13,
    fontWeight: 700
  },
  arrowIcon: {
    marginBottom: '0px !important',
    marginLeft: '20px !important'
  },
  dateRangePicker: {
    position: 'absolute',
    // left: -165,
    top: -50,
    zIndex: 1
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))
export default useStyles
